import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=42597bfc&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=ts&"
export * from "./Tag.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=42597bfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42597bfc",
  null
  
)

export default component.exports